import templateUrl from "./multilevel-checkbox.html";
import filter from "lodash/filter";

export const multilevelCheckboxComponent = {
  templateUrl,

  //bindings for title, onChange function and data to be filtered
  bindings: {
    title: "<",
    status: "<",
    onChange: "&",
    viewType: "@",
    onViewMore: "&",
    checkboxList: "<",
    showViewMore: "<",
  },

  //controller for rangepickerComponent
  controller: class MultilevelCheckboxComponent {
    constructor($state, $scope, $filter) {
      "ngInject";

      this.$state = $state;
      this.$scope = $scope;
      this.$filter = $filter;
    }

    $onInit() {
      const thisScope = this;
      this.parentArray = [];
      this.childArray = [];
      this.isTrue = false;
      this.$scope.$on("backDropClick", function (e) {
        thisScope.status = false;
        thisScope.isOpen = false;
        thisScope.$filter.isOpen = false;
      });
    }

    selectedData(parent, current) {
      const parentIds = (this.parentArray = this.checkboxList
        .filter((option) => option.isSelected)
        .map((option) => option.id));
      return {
        details: {
          parent: {
            id: parent.id,
            name: parent.name,
            isSelected: parent.isSelected,
          },
          selectedParentItems: parentIds,
          selectedChildItems: this.childArray,
          clickedItem: current.id,
        },
      };
    }

    //function to filter parent
    parentCheckboxClicked(parent) {
      if (parent.isSelected) {
        parent.isSelected = true;
        if (parent.children) {
          parent.children.map((child) => {
            child.isSelected = true;
            if (this.childArray.indexOf(child.id) !== -1)
              this.childArray.splice(this.childArray.indexOf(child.id), 1);
          });
        }
      } else {
        parent.isSelected = false;
        if (parent.children) {
          parent.children.map((child) => {
            child.isSelected = false;
          });
        }
      }
      this.onChange(this.selectedData(parent, parent));
    }

    //function to filter child
    childCheckboxClicked(child, parent) {
      var selectedCat = filter(parent.children, { isSelected: true });
      if (selectedCat.length === parent.children.length) {
        parent.isSelected = true;
        this.parentArray.push(parent.id);
        parent.children.map((child) => {
          if (this.childArray.indexOf(child.id) !== -1)
            this.childArray.splice(this.childArray.indexOf(child.id), 1);
        });
      } else {
        if (child.isSelected) {
          this.childArray.push(child.id);
        } else {
          if (this.childArray.indexOf(child.id) !== -1)
            this.childArray.splice(this.childArray.indexOf(child.id), 1);

          if (this.parentArray.indexOf(parent.id) !== -1) {
            parent.children.map((child) => {
              if (child.isSelected) {
                this.childArray.push(child.id);
              }
            });
            this.parentArray.splice(this.parentArray.indexOf(parent.id), 1);
            parent.isSelected = false;
          }
        }
      }
      this.onChange(this.selectedData(parent, child));
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/common/components/multilevel-checkbox/multilevel-checkbox.component.js